import React from "react";
import AboutUs from "../components/AboutUs/aboutus";
import NavbarShared from "../components/ui/NavbarShared/NavbarShared";
function About() {
  return (
    <>
      <NavbarShared/>
      <AboutUs />
    </>
  );
}

export default About;
